import React,{useEffect,useRef,useState} from "react";
import css from "./CopyButton.module.css";
import {fadeIn,fadeOut} from "vritra";
import {clipboard0,check0} from "Assets";


export default function CopyButton(props){
    const {text}=props;
    const [copied,setCopied]=useState(false);
    const refs=useRef([useRef(),useRef()]).current;
    useEffect(()=>{
        let timeout;
        const elements=refs.map(ref=>ref.current);
        if(copied){elements.reverse()};
        elements.forEach((element,i)=>{
            if(i){
                fadeIn(element,"block",350);
                timeout=setTimeout(()=>{setCopied(false)},1000);
            }
            else{fadeOut(element)}
        });
        return timeout&&(()=>{clearTimeout(timeout)});
    },[copied]);
    return navigator.clipboard&&(
        <button className={css.copybutton}>
            <img 
                ref={refs[1]} 
                className={css.copier}
                style={{opacity:copied?0:1}}
                src={clipboard0(majorColor)}
                onClick={()=>{
                    navigator.clipboard.writeText(text);
                    setCopied(true);
                }}
            />
            <img ref={refs[0]} className={css.sign} src={check0(minorColor)}/>
        </button>
    )
}
